import { action, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Polyline } from 'react-google-maps';

import { Iui } from '../../';

import Loading from '../Loading';
import MapMarker from '../MapMarker';
import { ILine } from '../../models/line';
import SearchPanel from './SearchPanel';
import SimpleMap from '../SimpleMap';

const apiKey = process.env.GOOGLE_MAPS_API_KEY;


@inject('ui')
@observer
class SearchByAccess extends React.Component<{ ui?: Iui }, {}> {
  constructor(props: { ui?: Iui }) {
    super(props);
    makeObservable(this);
  }

  public componentDidMount() {
    this.props.ui.byAccess.update();
  }

  public render() {
    const { byAccess } = this.props.ui;
    return (
      <React.Fragment>
        <Loading isLoading={byAccess.isLoading} />
        <SearchPanel />
        { byAccess.showMap && this.renderMap() }
      </React.Fragment>
    );
  }

  public renderMap() {
    const { byAccess } = this.props.ui;
    return (
      <div className="resort-search__map-container">
        {byAccess.durationInHour &&<div className="resort-search__meta">{byAccess.durationInHour} 時間</div>}
        <SimpleMap
          loadingElement={<div className="resort-search__fill resort-search__map-loading">Loading</div>}
          containerElement={<div className="resort-search__fill" />}
          mapElement={<div id="resort-search-map--access" className="resort-search__fill" />}
          center={byAccess.mapCenter}
        >
          {this.renderOrigin()}
          {this.renderRoutes()}
          {byAccess.resorts.map((resort, i) => {
            const isOpen = byAccess.openIndex === i;
            return (
              <MapMarker
                isOpen={isOpen}
                handleClick={this.handleMarkerClick(i)}
                key={resort.resort_code}
                place={resort}
              />
            );
          })}
        </SimpleMap>
      </div>
    );
  }

  public renderOrigin() {
    const { byAccess } = this.props.ui;
    const origin = byAccess.currentOrigin;
    return (
      <MapMarker
        isOpen={true}
        handleClick={() => {}}
        key={origin.place_id}
        place={origin}
      />
    );
  }

  public renderRoutes() {
    const { path, duration } = this.props.ui.byAccess.access;
    if (path.length === 0) { return null; }
    const result = [];
    path.forEach((line: ILine, i) => {
      const { origin, dest } = line;
      if (!origin || !dest) { return; }
      const originToDest = [{ lat: origin.latitude, lng: origin.longitude }, { lat: dest.latitude, lng: dest.longitude }];
      const polyLineOptions = {
        strokeColor: '#007bff',
        strokeWeight: 4,
      };
      result.push(
        <React.Fragment key={dest.place_id}>
          {i !== path.length - 1 &&
            <MapMarker
              iconType="dot"
              isOpen={false}
              handleClick={() => {}}
              place={dest}
            />}
          <Polyline key={originToDest.map(p => p.lat).join('-')} path={originToDest} options={polyLineOptions} />
        </React.Fragment>
      );
    });
    return result;
  }

  @action.bound
  public handleMarkerClick(resortIndex: number): () => void {
    return () => {
      const { byAccess } = this.props.ui;
      const resort = byAccess.resorts[resortIndex];
      byAccess.mapCenter = { lat: resort.latitude, lng: resort.longitude };
      byAccess.openIndex = resortIndex;
      const origin = byAccess.currentOrigin;
      byAccess.updateAccess({ origin_id: origin.place_id, dest_id: resort.place_id });
    }
  }
}

export default SearchByAccess;
